import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked", "onClick"];
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import styled, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const previewCardTheme = {
  AVATAR_SIZE: 30,
  ICON_SIZE: 14,
  FONT_SIZE: 12,
  DEFAULT_WEIGHT: 400,
  DEMI_BOLD: 500,
  BOLD: 600,
  BOLDEST: 700,
  HEIGHT: '106px',
  LEFT_SIDEBAR_WIDTH: '30px'
};
export const PreviewCardLeftSidebar = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardLeftSidebar",
  componentId: "sc-10y0etu-0"
})(["display:flex;flex:0 0;flex-direction:column;align-items:center;justify-content:space-between;width:", ";margin-right:9px;"], previewCardTheme.LEFT_SIDEBAR_WIDTH);
export const PreviewCardBody = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardBody",
  componentId: "sc-10y0etu-1"
})(["width:100%;"]);
export const PreviewCardSourceIconWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardSourceIconWrapper",
  componentId: "sc-10y0etu-2"
})(["display:flex;align-items:center;margin-left:6px;max-width:", "px;"], previewCardTheme.ICON_SIZE);
export const PreviewCardNameWrapper = styled.span.withConfig({
  displayName: "PreviewCardStyles__PreviewCardNameWrapper",
  componentId: "sc-10y0etu-3"
})(["", " ", ""], ({
  isUnread
}) => isUnread && css(["font-weight:", ";font-size:16px;color:", ";"], previewCardTheme.BOLDEST, ({
  theme
}) => theme.color['temp-do-not-use-fill-surface-recessed']), ({
  isUnknownContact
}) => isUnknownContact && css(["font-size:16px;color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardHeaderWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardHeaderWrapper",
  componentId: "sc-10y0etu-4"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;margin-top:4px;font-size:16px;line-height:22px;color:", ";padding-left:6px;", ""], ({
  theme
}) => theme.color['temp-do-not-use-fill-surface-recessed'], ({
  isUnread
}) => css(["font-weight:", " !important;"], isUnread ? previewCardTheme.BOLDEST : previewCardTheme.DEFAULT_WEIGHT));
export const PreviewCardContentWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardContentWrapper",
  componentId: "sc-10y0etu-5"
})(["display:flex;flex-direction:column;width:100%;color:", ";margin-top:6px;"], ({
  theme
}) => theme.color['temp-do-not-use-fill-surface-recessed']);
export const PreviewCardContentTextWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardContentTextWrapper",
  componentId: "sc-10y0etu-6"
})(["word-break:break-word;font-weight:", ";font-size:14px;line-height:24px;max-width:100%;padding-left:6px;", ";", ";", ";"], previewCardTheme.DEFAULT_WEIGHT, ({
  isComment
}) => isComment && css(["border-radius:12px;background-color:", ";padding:0px 6px 0px 6px;"], ({
  theme
}) => theme.color['fill-accent-yellow-hover']), ({
  hasSLA
}) => hasSLA && css(["max-width:90%;margin-right:30px;"]), ({
  hasNoConversation
}) => hasNoConversation && css(["color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardContentHeaderWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardContentHeaderWrapper",
  componentId: "sc-10y0etu-7"
})(["width:100%;display:flex;flex-direction:row;margin-bottom:4px;font-weight:", ";font-size:15px;line-height:20px;padding-left:6px;", " ", ""], previewCardTheme.DEFAULT_WEIGHT, ({
  isUnread
}) => isUnread && css(["font-weight:", ";"], previewCardTheme.BOLD), ({
  isUnknownContact
}) => isUnknownContact && css(["color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardCheckboxWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardCheckboxWrapper",
  componentId: "sc-10y0etu-8"
})(["margin:5px;", ""], ({
  checked
}) => checked && `
      &&& {
        display: block !important;
      }
    `);
export const PreviewCardCheckbox = _ref => {
  let {
      checked,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(PreviewCardCheckboxWrapper, {
      checked: checked,
      children: /*#__PURE__*/_jsx(Checkbox, Object.assign({
        checked: checked,
        onClick: onClick
      }, props))
    })
  );
};
PreviewCardCheckbox.displayName = 'PreviewCardCheckbox';
export const PreviewCardWrapper = styled.div.withConfig({
  displayName: "PreviewCardStyles__PreviewCardWrapper",
  componentId: "sc-10y0etu-9"
})(["background-color:", ";display:flex;flex-direction:row;flex-shrink:0;height:", ";width:100%;cursor:pointer;border-bottom:solid 1px ", ";border-left:solid 4px transparent;padding:12px 12px 12px 8px;", "{display:none !important;}#preview-card-channel-icon{display:block !important;}&:hover{", "{display:", " !important;}#preview-card-channel-icon{display:", " !important;}", " > *{color:", " !important;}}&:hover,&:focus{background-color:", " !important;}", " ", " ", ""], ({
  theme
}) => theme.color['fill-surface-default'], previewCardTheme.HEIGHT, ({
  theme
}) => theme.color['border-core-subtle'], PreviewCardCheckboxWrapper, PreviewCardCheckboxWrapper, ({
  disabled
}) => disabled ? 'none' : 'block', ({
  hideBulkSelectCheckbox
}) => hideBulkSelectCheckbox ? 'block' : 'none', PreviewCardLeftSidebar, ({
  theme
}) => theme.color['icon-core-subtle'], ({
  theme
}) => theme.color['fill-accent-blue-subtle'], ({
  disabled
}) => disabled && css(["&&{color:", ";cursor:not-allowed;opacity:0.25;}"], ({
  theme
}) => theme.color['icon-primary-disabled']), ({
  isSelected
}) => isSelected && css(["&&&{background-color:", " !important;border-left-color:", ";}"], ({
  theme
}) => theme.color['fill-accent-blue-subtle'], ({
  theme
}) => theme.color['fill-accent-blue-default']), ({
  isUnread
}) => !isUnread && css(["&&{background-color:", ";}"], ({
  theme
}) => theme.color['fill-field-default']));